import { cn } from '@nexelem/utils';
import { WeekNumberProps, DateRange, useDayPicker, PropsRange } from 'react-day-picker';
import { MouseEventHandler } from 'react';
import { isSameDay } from 'date-fns';
import { CalendarButton } from './CalendarButton';

export const WeekNumberButton = ({ className, children, week }: WeekNumberProps) => {
  const { selected, dayPickerProps } = useDayPicker<{ mode: 'range' }>();

  const onSelect = (dayPickerProps as PropsRange).onSelect;

  const isWeekSelected =
    selected?.from &&
    selected?.to &&
    isSameDay(selected.from, week.days[0].date) &&
    isSameDay(selected.to, week.days[week.days.length - 1].date);

  const handleSelect: MouseEventHandler<HTMLButtonElement> = (e) => {
    if (!week.days.length) {
      return;
    }

    const firstDay = week.days[0].date;
    const lastDay = week.days[week.days.length - 1].date;

    const range: DateRange = {
      from: firstDay,
      to: lastDay,
    };

    onSelect?.(range, firstDay, {}, e);
  };

  return (
    <td className={cn('box-border flex h-12 w-12 items-center justify-center', className)}>
      <CalendarButton
        className={cn(
          isWeekSelected &&
            '[&_.active-button]:bg-surface-focus [&_.active-button]:text-text-primary-inverse [&:hover_.active-button]:bg-icon-hover!',
          'text-s16-sb',
        )}
        onClick={handleSelect}
      >
        {children}
      </CalendarButton>
    </td>
  );
};
